import React, { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const useScrollRestoration = () => {
  const history = useHistory();
  const location = useLocation();
  const scrollPositions = useRef({}); // To store scroll positions per pathname

  useEffect(() => {
    // Save scroll position before navigating away
    return history.listen((location, action) => {
      if (action === 'PUSH' || action === 'POP') {
        scrollPositions.current[location.key] = window.scrollY;
      }
    });
  }, [history]);

  useEffect(() => {
    // Restore scroll position after navigation
    const handleScrollRestoration = () => {
      const scrollY = scrollPositions.current[location.key] || 0;
      window.scrollTo(0, scrollY);
    };
    handleScrollRestoration();
  }, [location]);
};

export default useScrollRestoration;
